import React, {useMemo} from 'react';
import './Quote.css';
import {QUOTES} from "../../texts/quotes/quotes";
import {getRandomElement} from "../../utils/other/getRandomElement";
import {CONTROLS_COLOR} from "../../styles/constants";

// quotes — из какого набора брать случайную цитату (по умолчанию — из всех)
function Quote({quotes = QUOTES}) {
  const currentQuote = useMemo(() => {
    return getRandomElement(quotes);
    // Цитата выбирается один раз на показ: перерисовка модалки ее не меняет
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="quote-container">
      <div
        className="loading-screen-quote-text"
        style={{
          color: CONTROLS_COLOR,
        }}
      >
        «{currentQuote.quote}»
      </div>
      <div
        className="loading-screen-quote-author"
        style={{
          color: CONTROLS_COLOR,
        }}
      >
        {currentQuote.author}</div>
    </div>
  );
}

export default Quote;
